module.exports = __webpack_public_path__ + "img/50-percent-discount.792bbfa.svg";